/**
 * Retailer Connect map pin — design SVG (17×19), COCO Primary #30386C / Secondary #53EBE2
 */

const PRIMARY = '#30386C';
const SECONDARY = '#53EBE2';

/** Paths from design export */
const OUTER_PATH =
  'M14.5989 3.42158C15.3939 4.55676 15.8815 5.87849 16.0141 7.25806C16.1297 8.43799 15.9813 9.62888 15.5796 10.7443C15.1778 11.8598 14.5328 12.8718 13.6913 13.707L8.70592 18.7207C8.61814 18.8092 8.51371 18.8794 8.39865 18.9274C8.28359 18.9753 8.16018 19 8.03553 19C7.91089 19 7.78748 18.9753 7.67242 18.9274C7.55735 18.8794 7.45293 18.8092 7.36515 18.7207L2.36086 13.707C1.51938 12.8718 0.874368 11.8598 0.472612 10.7443C0.0708562 9.62888 -0.0775649 8.43799 0.0381169 7.25806C0.156043 6.07035 0.535556 4.92349 1.14939 3.89989C1.76323 2.87628 2.59615 2.00133 3.58833 1.33789C4.74322 0.571726 6.07683 0.117682 7.4593 0.0199727C8.84177 -0.0777365 10.226 0.184219 11.4772 0.780331C12.7283 1.37644 13.8038 2.2864 14.5989 3.42158Z';

const INNER_PATH =
  'M8.06302 3.80273C7.24697 3.80273 6.44925 4.04472 5.77073 4.49809C5.09222 4.95146 4.56337 5.59586 4.25109 6.34979C3.9388 7.10371 3.85709 7.93332 4.01629 8.73368C4.1755 9.53405 4.56846 10.2692 5.14549 10.8463C5.72253 11.4233 6.45771 11.8163 7.25807 11.9755C8.05844 12.1347 8.88804 12.053 9.64197 11.7407C10.3959 11.4284 11.0403 10.8995 11.4937 10.221C11.947 9.54251 12.189 8.74479 12.189 7.92874C12.1866 6.8352 11.7511 5.78714 10.9779 5.01389C10.2046 4.24064 9.15656 3.80516 8.06302 3.80273Z';

export const STORE_MAP_PIN_WIDTH = 17;
export const STORE_MAP_PIN_HEIGHT = 19;

/** Tip of pin in design space (bottom of outer path) */
const ANCHOR_X = 8.03553;
const ANCHOR_Y = 19;

const svgToDataUrl = (svg: string) => `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;

const pinSvg = () =>
  `<svg xmlns="http://www.w3.org/2000/svg" width="${STORE_MAP_PIN_WIDTH}" height="${STORE_MAP_PIN_HEIGHT}" viewBox="0 0 17 19" fill="none" role="img" aria-hidden="true">
  <path stroke="none" fill="${PRIMARY}" d="${OUTER_PATH}"/>
  <path stroke="none" fill="${SECONDARY}" d="${INNER_PATH}"/>
</svg>`;

export const getStoreMapPinIcon = (_selected: boolean): google.maps.Icon => ({
  url: svgToDataUrl(pinSvg()),
  scaledSize: new google.maps.Size(STORE_MAP_PIN_WIDTH, STORE_MAP_PIN_HEIGHT),
  anchor: new google.maps.Point(ANCHOR_X, ANCHOR_Y),
});
